import React from 'react';

/** Typography atoms — used across all blocks. */

export function Eyebrow({ children, tone = 'leaf', className = '', as: Tag = 'p' }) {
  const colors = {
    leaf: 'text-[#F26B1A]',
    ink: 'text-[#1F1D1A]/70',
    cream: 'text-[#FAF8F2]/85',
  };
  return (
    <Tag className={`text-[11.5px] uppercase tracking-[0.22em] font-medium ${colors[tone] || colors.leaf} ${className}`}>
      {children}
    </Tag>
  );
}

export function Headline({ children, size = 'xl', accent, className = '', as: Tag = 'h2', ...rest }) {
  const sizes = {
    sm: 'text-[28px] sm:text-[36px] lg:text-[44px]',
    md: 'text-[32px] sm:text-[44px] lg:text-[56px]',
    lg: 'text-[36px] sm:text-[52px] lg:text-[68px]',
    xl: 'text-[40px] sm:text-[60px] lg:text-[80px]',
    hero: 'text-[40px] sm:text-[64px] lg:text-[96px] xl:text-[112px]',
  };
  return (
    <Tag className={`font-display leading-[1.02] ${sizes[size] || sizes.xl} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}

export function Body({ children, size = 'md', muted = true, className = '', as: Tag = 'p' }) {
  const sizes = {
    sm: 'text-[13.5px] lg:text-[14px]',
    md: 'text-[15px] lg:text-[16.5px]',
    lg: 'text-[16.5px] lg:text-[18px]',
  };
  return (
    <Tag className={`${sizes[size] || sizes.md} leading-relaxed ${muted ? 'text-[#5C5852]' : ''} ${className}`}>
      {children}
    </Tag>
  );
}
